import { motion } from 'framer-motion';
import { Droplet, Factory, Zap, FlaskConical, Building2 } from 'lucide-react';

const industries = [
  {
    id: 1,
    title: 'Oil & Gas',
    icon: Droplet,
    description: 'Industri minyak dan gas bumi',
    image: 'https://images.unsplash.com/photo-1760507352617-2e91bd8955c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxvaWwlMjBnYXMlMjByZWZpbmVyeSUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwc2VjdG9yfGVufDB8fHx8MTc3MzExMDU3NHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    title: 'Manufacturing',
    icon: Factory,
    description: 'Industri manufaktur',
    image: 'https://images.unsplash.com/photo-1772376920691-3c454f7f80a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxvaWwlMjBnYXMlMjByZWZpbmVyeSUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwc2VjdG9yfGVufDB8fHx8MTc3MzExMDU3NHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    title: 'Power Plant',
    icon: Zap,
    description: 'Pembangkit listrik',
    image: 'https://images.unsplash.com/photo-1738162837335-3745e5d16c09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjbmMlMjBtYWNoaW5pbmclMjBpbmR1c3RyaWFsJTIwd29ya3Nob3AlMjBtZXRhbCUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc3MzExMDU2M3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Petrochemical',
    icon: FlaskConical,
    description: 'Industri petrokimia',
    image: 'https://images.unsplash.com/photo-1720036236727-009f5b6f5a20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxjbmMlMjBtYWNoaW5pbmclMjBpbmR1c3RyaWFsJTIwd29ya3Nob3AlMjBtZXRhbCUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc3MzExMDU2M3ww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 5,
    title: 'Heavy Industry',
    icon: Building2,
    description: 'Industri berat',
    image: 'https://images.unsplash.com/photo-1759159091728-e2c87b9d9315?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjbmMlMjBtYWNoaW5pbmclMjBpbmR1c3RyaWFsJTIwd29ya3Nob3AlMjBtZXRhbCUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc3MzExMDU2M3ww&ixlib=rb-4.1.0&q=85'
  }
];

export const IndustrySection = () => {
  return (
    <section 
      className="py-24 md:py-32 bg-[#f5f7fb]"
      data-testid="industry-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-[#001582]/10 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-[#FFC107] rounded-full" />
            <span className="text-[#001582] text-sm font-semibold uppercase tracking-wider">Sektor</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-6">
            Industri yang <span className="text-[#001582]">Dilayani</span>
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Kami melayani berbagai sektor industri dengan solusi engineering dan manufacturing terpadu.
          </p>
        </motion.div>

        {/* Industry Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {industries.map((industry, index) => (
            <motion.div
              key={industry.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
                <img 
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#001582] via-[#001582]/50 to-transparent" />
                <div className="absolute inset-0 flex flex-col items-center justify-end p-4 text-center">
                  <div className="w-12 h-12 bg-[#FFC107] rounded-xl flex items-center justify-center mb-3 transform transition-transform group-hover:scale-110">
                    <industry.icon className="w-6 h-6 text-[#001582]" />
                  </div>
                  <h4 className="font-heading font-bold text-white text-sm md:text-base">
                    {industry.title}
                  </h4>
                  <p className="text-slate-300 text-xs mt-1 hidden md:block">
                    {industry.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;
